import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from "../../shared";
import { WFDashboardIssuePerAssigneeResponseDto } from '../../../data-transfer-objects/wf/wf-dashobard-issue-per-assignee-dto.model';


@Injectable({ providedIn: 'root' })
export class DashboardIssuesPerAssigneeReport extends BaseApiTemplateService<WFDashboardIssuePerAssigneeResponseDto> {
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'dashboard/issue-per-assignee-report';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.WF_PREFIX + 'dashboard/issue-per-assignee-report';
    this.httpClient = theHttp;
    }

    getIssuePerAssigneeReport(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<WFDashboardIssuePerAssigneeResponseDto>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      const UrlByCriteria = this.apiUrl + '?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<WFDashboardIssuePerAssigneeResponseDto>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }
}